import { ArrowRightStartOnRectangleIcon, ChartBarIcon, Cog8ToothIcon, MapPinIcon, ShoppingBagIcon, UserGroupIcon } from '@heroicons/react/24/outline'
import { useAuth } from '../context/auth-context'
import React, { useMemo } from 'react'
import { Col, Container, Nav, Row, Stack } from 'react-bootstrap'
import { Link, Outlet, useLocation } from 'react-router-dom'

export interface SiteMap {
    label: string;
    link: string;
    icon: React.ReactNode;
    hrule: boolean;
    logout?: () => void;
}

const Dashboard = () => {
    
    const { logout } = useAuth();
    const { pathname } = useLocation();

    const sitemaps: SiteMap[] = useMemo(() => [
        {
            label: 'Your Orders',
            link: '/customer/dashboard/orders',
            icon: <ShoppingBagIcon width={23} height={23} />,
            hrule: false,
        },
        {
            label: 'Track Your Order',
            link: '/customer/dashboard/track-order',
            icon: <ChartBarIcon width={23} height={23} />,
            hrule: false,
        },
        {
            label: 'Shipping Address',
            link: '/customer/dashboard/shipping-address',
            icon: <MapPinIcon width={23} height={23} />,
            hrule: false,
        },
        {
            label: 'Account Settings',
            link: '/customer/dashboard/settings',
            icon: <UserGroupIcon width={23} height={23} />,
            hrule: false,
        },
        {
            label: '',
            link: '',
            icon: <hr key={'hr'} />,
            hrule: true,
        },
        {
            label: 'Logout',
            link: '#',
            icon: <ArrowRightStartOnRectangleIcon width={23} height={23} />,
            hrule: false,
            logout: logout,
        },
    ], []);

    return (
        <Container>
            <Row>
                <Col sm={12} md={2} style={{
                    borderRight: '1px solid #ecf0ef'
                }}>
                    <Nav className="my-5 flex-column">
                        {sitemaps.map((sitemap: SiteMap, i: number) => {
                            return sitemap.hrule ? sitemap.icon : (
                                <Nav.Link 
                                    key={`nav-${i}`}
                                    onClick={() => sitemap.logout ? sitemap.logout() : null} 
                                    as={Link} 
                                    to={sitemap.link} 
                                    className={`sub-nav my-1 ${sitemap.link === pathname ? 'active' : ''}`}
                                >
                                    <Stack direction='horizontal' className='d-flex justify-content-start align-items-center'>
                                        {sitemap.icon}
                                        <Container as="span" style={{ fontSize: '.8rem' }}>{sitemap.label}</Container>
                                    </Stack>
                                </Nav.Link>
                            )
                        })}
                    </Nav>
                </Col>
                <Col sm={12} md={10}>
                    <Container className='my-5'>
                        <Outlet />
                    </Container>
                </Col>
            </Row>
        </Container>
    )
}

export default Dashboard
